/* eslint-disable */
jQuery(function ($) {
	// Add page loader when checkout is processing
	$( document ).ajaxSend(function( event, xhr, settings ) {
		if ( $( 'form.checkout' ).length && settings.data !== undefined && settings.data.indexOf( '&woocommerce-process-checkout-nonce=' ) !== -1 ) {
			$( '#page' ).prepend( '<span class="checkout-overlay"><i class="spinner"></i></span>' );
		}
	});
	$( document ).ajaxComplete(function( event, xhr, settings ) {
		if ( $( 'form.checkout' ).length && settings.data !== undefined && settings.data.indexOf( '&woocommerce-process-checkout-nonce=' ) !== -1 ) {
			$( '#page .checkout-overlay' ).remove();
		}
	});

	// Checkout
	$( document.body ).on( 'updated_checkout', function() {
		//Disable copy and paste to confirm email address field
		var user_email     = document.getElementById( 'billing_email-2' );
		if ( null !== user_email && user_email.length ) {
			user_email.onpaste = function(e) {
				alert( 'Please type this email address manually to confirm' );
				e.preventDefault();
			}
		}
		//Force minimum length on username
		if ( $( '#account_username' ).length ) {
			$( '.place-order' ).on( 'click', '#place_order', function( e ) {
				var user_name = $( '#account_username' ).val();
				if ( user_name.length < 3 ) {
					e.preventDefault();
					$( '#account_username' ).css( 'border-color', '#fb7f88' );
					location.href = '#wc_customer_source_checkout_field';
					$( '#account_username' ).trigger( 'focus' );
					alert( 'Your username must be at least 3 characters long' );
				} else {
					$( '#account_username' ).css( 'border-color', '#e5e5e5' );
				}
			});
		}
	});
	// show coupon form when coupon gets removed
	$( document.body ).on( 'removed_coupon_in_checkout', function( coupon_event ) {
		console.log( 'coupon_removed' );
		$( '.woocommerce-form-coupon-toggle' ).show();
	});
	// Hide coupon form on gift subscription page
	$( 'body.postid-32637 .checkout_coupon.woocommerce-form-coupon' ).hide();

	// Show notice when coupon added automatically
	// Get query string
	const params = new Proxy( new URLSearchParams( window.location.search ), {
		get: ( searchParams, prop ) => searchParams.get( prop ),
	});
	let coupon = params.coupon_code;
	if ( null !== coupon && coupon.length > 0 ) {
		// Trigger events for applying coupon
		$( document.body ).trigger( 'applied_coupon_in_checkout', [ coupon ] );
		$( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
		$( '.woocommerce-form-coupon-toggle' ).hide();
		//$( '<div class="woocommerce-message" role="alert">Coupon code applied successfully.</div>' ).insertAfter( '.checkout_coupon.woocommerce-form-coupon' );
		//$( '.woocommerce-notices-wrapper' ).append( '<div class="woocommerce-message" role="alert">Coupon code applied successfully.</div>' );
	}
});